import { createContext } from 'react';
import { IntercomContextType } from './types';
import { partnerSupplierAppURL } from '@/utils/environment';
import { Platform } from 'react-native';
import { SessionService } from '@domain/auth/blocs/services/session-service';

const BASE_URL = Platform.OS === 'web' ? '' : partnerSupplierAppURL;

export const IntercomContext = createContext<IntercomContextType | null>(null);

export const getIntercomUserHash = async (): Promise<string | null> => {
  try {
    const token = await SessionService.getIdToken();
    const hashResponse = await fetch(`${BASE_URL}/api/_intercom`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Pepper-App-Platform': Platform.OS,
      },
    });
    const { hash } = await hashResponse.json();
    return hash;
  } catch (e) {
    return null;
  }
};
